// extracted by mini-css-extract-plugin
module.exports = {"page":"app-module--page--1lltx","content":"app-module--content--2VLat"};